<div mat-dialog-title>
  {{ 'Add note' | translate }}
</div>
<mat-dialog-content>
  <form class="container" [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Note' | translate }}</mat-label>
      <textarea matInput required formControlName="note"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" mat-dialog-close>{{ 'Cancel' | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="addNote()">{{ 'Add note' | translate
    }}</button>
</mat-dialog-actions>